import React, { useEffect, useState } from "react";
import { mixPostV1 } from "../../services/mixin";
import { IMAGE_URL } from "../../env";
import { Flex, PaginationProps, Select, Table, TableColumnsType } from "antd";
import { HistoryLuckyGame, HistoryMatch } from "./Member";
import { numberFormat } from "../Staff/component/TablesColumns";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { ArrowSquareDown } from "iconsax-react";
import { Option } from "antd/es/mentions";

interface MemberDetailProps {
  memberData: {
    app_id: number;
    avatar: string;
    birthday: string;
    check_in_limit: any;
    customer_name: string;
    date_register: string;
    days_used: number;
    hand_register: string;
    hour_allow_match: number | null;
    is_locked: number;
    last_match_time: string;
    level: number[];
    phone_number: string;
    role_id: number;
    role_name: string;
    time_joint: string;
    total_match: number;
  };
  isShow: boolean;
  onClose: () => void;
  loading: boolean;
  historyMatch: HistoryMatch[];
  paramsMatch: {
    totalRowMatch: number;
    page_number: number;
    limit: number;
    pageName: string;
    totalRowGame: number;
    page_number_game: number;
    x: number;
  };
  comboLimit: { value: number; label: number | string }[];
  onPageMatchChange: (page: number) => void;
  onTableMatchChange?: (data: any) => void;
  historyLuckyGame: HistoryLuckyGame[];
  onPageGameChange: (page: number) => void;
  onTableGameChange?: (data: any) => void;
  updateLimitMember?: (value: any, id: number) => void;
  updateHourMatchMember?: (value: any, id: number) => void;
}
interface DataType {
  //   key: React.Key;
  cash_out: number;
  date_checkin: string;
  id: number;
  machine_number: string;
  match_amount: number;
  shift: string;
  time_checkin: string;
  voucher_id: number;
}
const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};
const MemberDetailInfomationPoup: React.FC<MemberDetailProps> = ({
  memberData,
  isShow,
  onClose,
  loading,
  historyMatch = [],
  paramsMatch,
  comboLimit,
  onPageMatchChange,
  onTableMatchChange,
  historyLuckyGame = [],
  onPageGameChange,
  onTableGameChange,
  updateLimitMember,
  updateHourMatchMember,
}) => {
  const [activeTab, setActiveTab] = useState("match"); // State to manage active tab

  if (!isShow || !memberData) return null;

  const styles = {
    overlay: {
      position: "fixed" as const,
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    popup: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "20px",
      width: "80%",
      maxWidth: "800px",
      maxHeight: "90vh",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)",
      position: "relative" as const,
      overflow: "hidden",
      color: "#000",
      fontFamily: "Arial, sans-serif",
    },
    closeBtn: {
      position: "absolute" as const,
      top: "10px",
      right: "10px",
      background: "none",
      border: "none",
      fontSize: "18px",
      cursor: "pointer",
      color: "#000",
    },
    title: {
      textAlign: "center" as const,
      marginBottom: "20px",
      fontWeight: "bold",
      fontSize: "24px",
      color: "#000",
    },
    content: {
      display: "flex",
      gap: "20px",
    },
    avatarColumn: {
      display: "flex",
      flexDirection: "column" as const,
      gap: "12px",
    },
    avatar: {
      width: "120px",
      height: "120px",
      borderRadius: "8px",
      border: "2px solid #444",
    },
    info: {
      flex: 1,
      display: "flex",
      flexDirection: "column" as const,
      gap: "10px",
    },
    infoRow: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "10px",
    },
    label: {
      fontWeight: "bold",
      width: "150px",
      textAlign: "left" as const,
      marginRight: "10px",
    },
    value: {
      flex: 1,
      textAlign: "left" as const,
    },
    rightInfo: {
      flex: 1,
      display: "flex",
      flexDirection: "column" as const,
      gap: "10px",
    },
    tabs: {
      display: "flex",
      borderBottom: "2px solid #000",
      marginBottom: "10px",
    },
    tab: {
      padding: "10px 20px",
      cursor: "pointer",
      fontWeight: "bold",
      borderBottom: "2px solid transparent",
    },
    activeTab: {
      borderBottom: "2px solid #000",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse" as const,
      marginTop: "20px",
    },
    tableContainer: {
      maxHeight: "300px",
      overflowY: "auto" as const,
      marginTop: "20px",
      border: "1px solid #444",
    },
    th: {
      border: "1px solid #444",
      padding: "8px",
      backgroundColor: "#f0f0f0",
      textAlign: "center" as const,
      position: "sticky" as const,
      top: 0,
      zIndex: 1,
    },
    td: {
      border: "1px solid #444",
      padding: "8px",
      textAlign: "center" as const,
    },
    noData: {
      textAlign: "center" as const,
      marginTop: "20px",
      fontStyle: "italic",
      color: "#aaa",
    },
  };
  const Matchcolumns: TableColumnsType<DataType> = [
    {
      title: "Shift",
      dataIndex: "shift",
      key: "shift",
    },
    {
      title: "Machine",
      dataIndex: "machine_number",
      key: "machine_number",
    },
    {
      title: "Time",
      dataIndex: "time_checkin",
      key: "time_checkin",
      render: (value, record, index) => (
        <span>
          {value}, {record.date_checkin}
        </span>
      ),
    },
    {
      title: "Match",
      dataIndex: "match_amount",
      key: "match_amount",
      render: (value, record, index) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Cashout",
      dataIndex: "cash_out",
      key: "cash_out",
      render: (value, record, index) => <span>{numberFormat(value)}</span>,
    },
  ];
  const Gamecolumns: TableColumnsType<HistoryLuckyGame> = [
    {
      title: "Time",
      dataIndex: "award_date",
      key: "award_date",
    },
    {
      title: "App ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
    },
  ];
  const renderTable = () => {
    if (activeTab === "match") {
      return (
        <Table
          columns={Matchcolumns}
          dataSource={historyMatch}
          className="rs-table hitoryTable text-nowrap t-table-member"
          //   scroll={{
          //     x: true,

          //   }}
          scroll={{
            x: "max-content",
            y: 300,
          }}
          loading={loading}
          showSorterTooltip={false}
          tableLayout="fixed"
          pagination={{
            total: paramsMatch.totalRowMatch,
            pageSize: paramsMatch.limit,
            position: ["bottomCenter"],
            showSizeChanger: true,
            showTitle: false,
            current: paramsMatch.page_number,
            itemRender: customPrevNext,
            onChange: (e) => onPageMatchChange(e),
          }}
          onChange={onTableMatchChange}
        />
      );
    } else if (activeTab === "luckyGame") {
      return (
        <Table
          columns={Gamecolumns}
          dataSource={historyLuckyGame}
          className="rs-table hitoryTable text-nowrap t-table-member"
          scroll={{
            x: "max-content",
            y: 300,
          }}
          loading={loading}
          showSorterTooltip={false}
          tableLayout="fixed"
          pagination={{
            total: paramsMatch.totalRowGame,
            pageSize: paramsMatch.limit,
            position: ["bottomCenter"],
            showSizeChanger: true,
            showTitle: false,
            current: paramsMatch.page_number_game,
            itemRender: customPrevNext,
            onChange: (e) => onPageGameChange(e),
          }}
          onChange={onTableGameChange}
        />
      );
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <button style={styles.closeBtn} onClick={onClose}>
          X
        </button>
        <h2 style={styles.title}>MEMBER DETAIL INFORMATION</h2>

        <div style={styles.content}>
          <div style={styles.avatarColumn}>
            <img
              src={`${IMAGE_URL}${memberData.avatar}`}
              alt="avatar"
              style={styles.avatar}
            />
            <img
              src={`${IMAGE_URL}${memberData.hand_register}`}
              alt="hand_register"
              style={styles.avatar}
            />
          </div>
          <div style={styles.info}>
            <div style={styles.infoRow}>
              <p style={styles.label}>Name:</p>
              <p style={styles.value}>{memberData.customer_name}</p>
            </div>
            <div style={styles.infoRow}>
              <p style={styles.label}>Birthday:</p>
              <p style={styles.value}>{memberData.birthday}</p>
            </div>
            <div style={styles.infoRow}>
              <p style={styles.label}>Role:</p>
              <p style={styles.value}>{memberData.role_name}</p>
            </div>
            <div style={styles.infoRow}>
              <p style={styles.label}>Total Matches:</p>
              <p style={styles.value}>{memberData.total_match}</p>
            </div>
            <div style={styles.infoRow}>
              <p style={styles.label}>Daily Claim Limit:</p>
              <p style={styles.value}>
                <Select
                  defaultValue={
                    memberData.check_in_limit
                      ? memberData.check_in_limit.toString()
                      : "none"
                  }
                  className="custom-select"
                  style={{ width: 90, height: 24 }}
                  onChange={(value) => {
                    updateLimitMember?.(Number(value), memberData.app_id);
                  }}
                >
                  {comboLimit.map((item) => (
                    <Option
                      key={item?.value?.toString()}
                      value={item.value.toString()}
                    >
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </p>
            </div>
            <div style={styles.infoRow}>
              <p style={styles.label}>Member Since:</p>
              <p style={styles.value}>
                {memberData.time_joint} ({memberData.days_used} days)
              </p>
            </div>
          </div>
          <div style={styles.rightInfo}>
            <div style={styles.infoRow}>
              <p style={styles.label}>ID:</p>
              <p style={styles.value}>{memberData.app_id}</p>
            </div>
            <div style={styles.infoRow}>
              <p style={styles.label}>Phone Number:</p>
              <p style={styles.value}>{memberData.phone_number}</p>
            </div>
            <div style={styles.infoRow}>
              <p style={styles.label}>Level:</p>
              <p style={styles.value}>{memberData.level.toString()}</p>
            </div>
            <div style={styles.infoRow}>
              <p style={styles.label}>Last Claimed:</p>
              <p style={styles.value}>{memberData.last_match_time}</p>
            </div>
            <div style={styles.infoRow}>
              <p style={styles.label}>Claim Countdown:</p>
              <p style={styles.value}>
                {/* {memberData.hour_allow_match
                  ? memberData.hour_allow_match + "hrs"
                  : "None"}{" "} */}
                <Select
                  defaultValue={
                    memberData.hour_allow_match
                      ? memberData.hour_allow_match.toString()
                      : "0"
                  }
                  className="custom-select"
                  style={{ width: 90, height: 24 }}
                  onChange={(value) => {
                    updateHourMatchMember?.(Number(value), memberData.app_id);
                  }}
                >
                  {comboLimit.map((item) => (
                    <Option
                      key={item?.value?.toString()}
                      value={item.value.toString()}
                    >
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </p>
            </div>
          </div>
        </div>

        <div style={styles.tabs}>
          <div
            style={{
              ...styles.tab,
              ...(activeTab === "match" ? styles.activeTab : {}),
            }}
            onClick={() => setActiveTab("match")}
          >
            Match History
          </div>
          <div
            style={{
              ...styles.tab,
              ...(activeTab === "luckyGame" ? styles.activeTab : {}),
            }}
            onClick={() => setActiveTab("luckyGame")}
          >
            Lucky Game
          </div>
        </div>

        {renderTable()}
      </div>
    </div>
  );
};

export default MemberDetailInfomationPoup;
